// import { data } from "isotope-layout";
import PropTypes from "prop-types";
import React from 'react';
// import {Link} from "react-router-dom";
import FileName from '../../data/pic/filename.json';



const WorkDetailsContainer = () => {
    // const cate = data.categories.map((value, i) => {
    //     return(
    //         <span className="d-inline" key={i}>{value}{i !== data.categories.length - 1 && " , "}</span>
    //     )
    // })
    return (
        <div className="section section-padding">
            <div className="container">
                <div className="row pt--100 pb--80">

                    <div className="col-lg-4 col-md-6 col-12">
                        <div className="work-left work-details" data-aos="fade-up">
                            <div className="portfolio-main-info">
                                <h2 className="title">Wonderful Moments </h2>
                                <div className="work-details-list mt-12">

                                    <div className="details-list">
                                        <label>Years</label>
                                        <span>2023</span>
                                    </div>
                                    <div className="details-list">
                                        <label>Date</label>
                                        <span>14th-18th, July</span>
                                    </div>

                                    <div className="details-list">
                                        <label>Location</label>
                                        <span>Shenzhen, China</span>
                                    </div>


                                    {/* <div className="details-list">
                                        <label>Awards</label>
                                        <span>{data.awards}</span>
                                    </div> */}

                                </div>
                                {/* <div className="work-share pt--70 pt_md--40 pt_sm--40">
                                    <h6 className="heading heading-h6">SHARE</h6>
                                </div> */}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-7 col-md-6 offset-lg-1 col-12">
                        <div className="work-left work-details mt-6">
                            <div className="work-main-info">
                                <div className="work-content">
                                    <h4 className="title" data-aos="fade-up">The Fourteenth International Conference on Swarm Intelligence (ICSI&apos;2023)</h4>

                                    <div className="desc mt-8">
                                        <p>
                                        Shenzhen, China - The Fourteenth International Conference on Swarm Intelligence (ICSI&apos;2023) was successfully held in Shenzhen on July 16, 2023. The conference brought together leading researchers, practitioners, and academics from around the world to explore the latest trends and advancements in swarm intelligence.
                                        </p>

                                        <p>
                                            The theme of ICSI&apos;2023 is &quot;Serving Life with Swarm Intelligence&quot;. The ICSI&apos;2023 provided an excellent opportunity and/or an academic forum for academics and practitioners to present and discuss the latest scientific results and methods, innovative ideas, and advantages in theories, technologies, and applications in swarm intelligence. The technical program covered a number of aspects of swarm intelligence and its related areas.

                                        </p>

                                        <p>
                                        The three-day conference featured keynote speeches, technical sessions, poster presentations, and workshops, covering a wide range of topics related to swarm intelligence, including swarm robotics, swarm optimization, swarm intelligence in social systems, and more. The conference also provided an excellent opportunity for researchers and practitioners to exchange ideas, network, and collaborate on new research projects.
                                        </p>





                                        {/* {data.body.map((value, i) => {
                                            return(
                                                <div key={i} className="content mb-5" data-aos="fade-up" dangerouslySetInnerHTML={{__html: value}} />
                                            )
                                        })} */}
                                        {/* DONE: fix the linkage problem  */}
                                        {/* <div className="work-btn" data-aos="fade-up">
                                            <a className="btn btn-primary btn-hover-secondary" href="www.baidu.com">Baidu</a>
                                        </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Opening Ceremony</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>The conference was inaugurated on July 15th at 8:30 AM, presided over by Professors Luo Wenjian and Shi Yuhui. Following the commencement, conference chair Professor Tan Ying delivered the opening speech. Professor Ying Tan reported on the current status of this year&apos;s conference and extended a warm welcome to everyone. </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-12">
                        <div className="custom-column-thumbnail mt-lg-14 mt-1" data-aos="fade-up">
                            <img className="w-50" src='./images/gallery/o1.jpg' alt="Agency" />
                            <img className="w-50" src='./images/gallery/o2.jpg' alt="Agency" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="custom-column-thumbnail mt-lg-14 mt-1" data-aos="fade-up">
                            <img className="w-50" src='./images/gallery/p4.jpg' alt="Agency" />
                            <img className="w-50" src='./images/gallery/group.jpg' alt="Agency" />
                        </div>
                    </div>
                </div>

                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Plenary Speech</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>This was followed by a plenary speech by guest speaker Professor Zhou Mengchu, focused on the &quot;Role of Autoencoders in Accelerating Swarm Optimizers to Solve High-dimensional Expensive Problems&quot;. An enthusiastic question and answer session ensued after the presentation.</p>
                                The conference resumed with a lecture from Prof. Subhabrata Banerjee on &quot;Swarm Intelligence Algorithms & Their Impact on Error Control Coding Scheme&quot;. The talk sparked lively discussion among participants.
                            </div>
                        </div>
                    </div>
                </div>

                <div className="custom-layout-gallery mt-lg-20 mt-12">
                    {/* big one */}
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/p1.jpg" alt="Agency" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/p6.jpg" alt="Agency" />
                            </div>
                        </div>


                    </div>
                    <br></br>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/p2.jpg" alt="Agency" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/q1.jpg" alt="Agency" />
                            </div>
                        </div>


                    </div>
                </div>


                {/* ---------------------------invited best student paper presentation */}

                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Plenary Speech</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>Following a group photo and a brief 20-minute intermission, another highlight of the conference was a presentation from guest speaker Professor Zhang Qingfu entitled &quot;Modelling and Solution Set Constraints in MOEA/D&quot;. A dynamic exchange of thoughts and ideas took place after the talk.

                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* gallery */}
                <div className="custom-layout-gallery mt-lg-20 mt-12">
                    {/* big one */}
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/p5.jpg" alt="Agency" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/q4.jpg" alt="Agency" />
                            </div>
                        </div>


                    </div>
                    <br></br>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img  src="./images/gallery/p7.jpg" alt="Agency" width="80%" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/q3.jpg" alt="Agency" />
                            </div>
                        </div>


                    </div>
                </div>
                {/* -------------------------------------------------------------- */}
                {/* -----------------------------------inv talk-------------------- */}
                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Invited Paper Presentations</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>At the end of the morning session of the conference, the authors of the best paper and best special session paper were introduced and they presented their work.</p>


                            </div>
                        </div>
                    </div>
                </div>
                {/* gallery */}
                <div className="custom-layout-gallery mt-lg-20 mt-12">
                    {/* big one */}
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img  src="./images/gallery/p9.jpg" alt="Agency"  />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/p10.jpg" alt="Agency" />
                            </div>
                        </div>


                    </div>
                    {/* <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/0246.jpg" alt="Agency" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/0246.jpg" alt="Agency" />
                            </div>
                        </div>


                    </div> */}
                </div>
                {/* -------------------------------------------------------------- */}
                {/* parellel sessions */}
                {/* -------------------------------------------------------------- */}
                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Parallel Sessions</h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>The conference continued on July 15th and the morning of July 16th with paper presentations by participating authors spread across five conference rooms. Attendees chose sessions based on their interests, leading to engaging conversations and fruitful interactions with the presenters.</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* gallery */}
                <div className="custom-layout-gallery mt-lg-20 mt-12">
                    {/* big one */}
                    {/* <div className="col-lg-12 my-6">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/plenary talk 1.jpg" alt="Agency" />
                            </div>
                        </div> */}
                    {/* small one */}

                    <div className="row">

                        {FileName.map((data, i) => {
                            return (
                                <div className="col-lg-4 col-md-4 col-12" key={i}>
                                    <div className="thumbnail" data-aos="fade-up">
                                        <img className="w-100" src={"./images/gallery/" + data.file} alt={data.file} />
                                    </div>
                                </div>
                            )
                        })}


                        {/* <div className="col-lg-4 col-md-4 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src={"./images/gallery/"+ data.file} alt="Agency" />
                            </div>
                        </div>  */}



                        {/* <div className="col-lg-4 col-md-4 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/0246.jpg" alt="Agency" />
                            </div>
                        </div> */}


                    </div>
                </div>
                {/* -------------------------------------------------------------- */}
                {/* award ceremony */}
                {/* -------------------------------------------------------------- */}
                <div className="row mt-lg-20 mt-12">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="digital-marketing" data-aos="fade-up">
                            <h3 className="heading heading-h3">Award Ceremony
                            </h3>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 col-12 offset-lg-1">
                        <div className="digital-marketing mt-lg-0 mt-6" data-aos="fade-up">
                            <div className="inner">
                                <p>On the evening of July 15th, a welcome dinner was held at 6 PM, marking a festive occasion where the winners of the Best Paper and Best Special Session Paper were announced and awarded. Prof. Ying  took a group photo with them. </p>
                                <p>
                                Additionally, Prof. Shi Yuhui announced the plans for ICSI&apos;2024, which will take place in Xining, Qinghai, China. We welcome everyone to attend the next conference.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* gallery */}
                <div className="custom-layout-gallery mt-lg-20 mt-12">
                    {/* big one */}
                    {/* <div className="col-lg-12 my-6">
                                        <div className="thumbnail" data-aos="fade-up">
                                            <img className="w-100" src="./images/gallery/plenary talk 1.jpg" alt="Agency" />
                                        </div>
                                    </div> */}
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/aw1.jpg" alt="Agency" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/aw2.jpg" alt="Agency" />
                            </div>
                        </div>


                    </div>
                    <br></br>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-12">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/b1.jpg" alt="Agency" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12 mt-lg-0 mt-md-0 mt-10">
                            <div className="thumbnail" data-aos="fade-up">
                                <img className="w-100" src="./images/gallery/b3.jpg" alt="Agency" />
                            </div>
                        </div>


                    </div>


                </div>


                {/* -------------------------------------------------------------- */}


            </div>
        </div>
    )
}

WorkDetailsContainer.propTypes = {
    data: PropTypes.object
};

export default WorkDetailsContainer;
